import { Modal, Descriptions, Tag, Button } from "antd";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import React from "react";
import type { ScheduleStore } from "../store";
import type { ScheduleLocation } from "../../FestivalCalcPage/types";
import { $parse } from "@opendash/plugin-parse";
import {  usePermission, usePermissions } from "@opendash/core";

const TYPE_LABELS: Record<string, string> = {
  general: "Allgemein",
  workshop: "Workshop",
  music_act: "Musikact",
};

const TYPE_COLORS: Record<string, string> = {
  general: "default",
  workshop: "blue",
  music_act: "purple",
};

interface Props {
  store: ScheduleStore;
  locations: ScheduleLocation[];
}

export const ScheduleItemModal = observer(({ store, locations }: Props) => {
  const item = store.selectedItem;
  const editPermission = usePermission("festival:timetable-admin");

  if (!item) return null;

  const location = locations.find((l) => l.id === item.locationId);
  const endTime = dayjs(item.startTime).add(item.durationMinutes, "minute");

  return (
    <Modal
      open
      title={item.title || "(kein Titel)"}
      footer={editPermission ? [
        <Button key="delete" type="primary" danger onClick={() => { store.deleteItem(item.objectId); store.selectItem(null); }}>
          Löschen
        </Button>
      ]: null}
      onCancel={() => store.selectItem(null)}
    >
      <Descriptions column={1} size="small">
        <Descriptions.Item label="Typ">
          <Tag color={TYPE_COLORS[item.type]}>{TYPE_LABELS[item.type] ?? item.type}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Ort">{location?.name ?? item.locationId}</Descriptions.Item>
        <Descriptions.Item label="Beginn">
          {dayjs(item.startTime).format("dd DD.MM. HH:mm")} Uhr
        </Descriptions.Item>
        <Descriptions.Item label="Ende">
          {endTime.format("dd DD.MM. HH:mm")} Uhr
        </Descriptions.Item>
        <Descriptions.Item label="Dauer">{item.durationMinutes} Min.</Descriptions.Item>
        {item.type === "workshop" && item.capacity != null && (
          <Descriptions.Item label="Kapazität">{item.capacity} Personen</Descriptions.Item>
        )}
        {item.description && (
          <Descriptions.Item label="Info">{item.description}</Descriptions.Item>
        )}
      </Descriptions>
    </Modal>
  );
});
